import { ElementRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { MandoobService } from 'src/app/options/mandoobs/mandoob.service';
import { Globle } from 'src/assets/globle';
import { MandoobStatment } from '../mandoobstatment.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-orders-mandoob-private',
  templateUrl: './orders-mandoob-private.component.html',
  styleUrls: ['./orders-mandoob-private.component.css']
})
export class OrdersMandoobPrivateComponent implements OnInit {

  reports: MandoobStatment[] = [];
  displayedColumns: string[] = ['date', 'userName', 'productName', 'userCatg', 'quantity', "total"];
  dataSource!: MatTableDataSource<MandoobStatment>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  mandoobs: { id: number, name: string }[] = [];
  spinnerOverlay = false;
  selectedMandoob!: number;
  lang = 'en';
  reportObj: MandoobStatment = {} as MandoobStatment;
  pageSize = 100;
  constructor(private service: ReportsService,
    private mandoobService: MandoobService,
    private translate: TranslateService,
    private localStorage: LocalStorageService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getManddobs();
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
    }, error => {
      console.log(error)
    })
  }

  get() {

    this.spinnerOverlay = true;
    this.service.getMandoobStatment(this.localStorage.retrieve('userInfo').mandoobId, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {
      let obj = data

      this.reports = [];
      if (obj.length > 0) {

        for (let i = 0; i < obj.length; i++) {
          this.reportObj = {} as MandoobStatment;
          this.reportObj.productName = obj[i]['product']['arabicName'];
          this.reportObj.userName = obj[i]['appUser']['fullName'];
          this.reportObj.userCategory = obj[i]['appUser']['userCategory']['name'];
          this.reportObj.total = obj[i]['total'];
          this.reportObj.quantity = obj[i]['quantity'];

          var date = new Date(obj[i]['date']);
          this.reportObj.date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
          this.reports.push(this.reportObj);
        }
      }
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف مندوب ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);
    doc.text(" المندوب : " + this.mandoobs.find(x => x.id == this.selectedMandoob)?.name, 150, 20, {
      isOutputRtl: true,

    });

    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }



    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#mandoobTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }


}
